import { hudPaths } from '../content';
import { ServiceArchitectureScreen } from '../sections';
import { PageActionBar } from './PageActionBar';

export const ServiceArchitecturePage = () => {
  return (
    <>
      <ServiceArchitectureScreen />
      <PageActionBar activePath={hudPaths.serviceArchitecture} ctaLabel="Open Architecture Planning Session" />
    </>
  );
};
